import {get,post,postWithConfig} from '@/utils/request'

const baseURL = '';//'https://capi.staff.xdf.cn/mock/925'
// const staffId = sessionStorage.getItem('currentStaffId') || ''
console.log('qwSendMessage')
/**
 * 获取群发任务
 */
export const getgroupSendTaskListApi = ()=>{
    return get(baseURL + '/api/group/send/task/list',{staffId: sessionStorage.getItem('currentStaffId')})
}

/**
 * 删除草稿任务
 * @param {*} taskId 
 * @returns 
 */
export const deleteGroupTask = (taskId)=>{
    return get(baseURL + '/api/group/send/task/delete',{taskId})
}

/**
 * 群发内容
 * @param {*} taskId 
 * @returns 
 */
 export const taskContentApi = (taskId)=>{
    return get(baseURL + '/api/task/content',{taskId})
}

/**
 * 发送明细
 * @param {*} taskId 
 * @returns 
 */
 export const sendDetailApi = (taskId,sendStatus)=>{
    return get(baseURL + '/api/send/detail',{taskId,sendStatus})
}
/**
 * 发送明细 精简版
 * @param {*} taskId 
 * @returns 
 */
export const sendDetailSimpleApi = (taskId)=>{
    return get(baseURL + '/api/send/detail/simple',{taskId})
}

/**
 * 新建/编辑群发任务
 * @param {
 * * {"creatorStaffId": "RenJinHui", "taskName": "群发任务", "taskId": "0f18f6cfa9c941aea5267ac8b19e3a63", "taskType": 1, "groupSendObjects": [{"name": "", "tabId": "", "sendTarget": [{"studentCode": "", "studentName": "", "nickName": "", "receiveName": "", "chatGroupName": null, "groupId": null}, {"studentCode": "BJ5863420336", "studentName": "王鹏飞北", "nickName": "xiaojing", "receiveName": "晓靖同学", "chatGroupName": null, "groupId": null}], "sendContent": [{"msgType": "text", "showContent": "", "sendContent": "#学生姓名# rfewrfwerf#学生昵称# Fwerfwerf\n", "filePaths": null, "fakeId": "luuza7rw533sn"}], "sendType": 1, "title": "群发1"}], "studentMessageDetails": [{"studentCode": "BJ1520886305", "studentName": "骆希", "nickName": "飞飞同学", "receiveName": "田飞飞", "chatGroupName": null, "groupId": null, "sendContents": [{"msgType": "text", "showContent": "", "sendContent": "骆希 rfewrfwerf飞飞同学 Fwerfwerf\n", "filePaths": null, "fakeId": "luuza7rw533sn", "tabId": "781b658a96e849c493862e00512b7be4"}]}, {"studentCode": "BJ5863420336", "studentName": "王鹏飞北", "nickName": "xiaojing", "receiveName": "晓靖同学", "chatGroupName": null, "groupId": null, "sendContents": [{"msgType": "text", "showContent": "", "sendContent": "王鹏飞北 rfewrfwerfxiaojing Fwerfwerf\n", "filePaths": null, "fakeId": "luuza7rw533sn", "tabId": "781b658a96e849c493862e00512b7be4"}]}]}
 * } params 
 * @returns 
 */
export const saveTask = (params={}) =>{
    return postWithConfig(baseURL + '/api/group/send/task/save',params,{
        timeout: 2 * 60 * 1000
    })
}

/**
 * 发送结果上报
 * @param {
 * 
 * } params 
 * @returns 
 */
export const taskResultReport = (params={})=>{
    return postWithConfig(baseURL + '/api/task/report',params,{
        timeout: 2 * 60 * 1000
    })
}

// 日志上报 taskId content
export const taskLogRepot = (params={}) => {
    return postWithConfig(baseURL + '/api/log/report',params,{
        timeout: 2 * 60 * 1000
    })
}


/**
 * 更新消息
 * @param {
 * chatGroupName
 * receiveName
 * studentCode
 * sendContents :[{messageId msgType  path sendContent tabId}]
 * } params 
 * @returns 
 */
export const updateStudentMsg = (params={}) =>{
    return post(baseURL + '/api/student/message/update',params)
}
